import createAPI from '../axios'

// 课程标准相关API
const courseStandardAdultEducation = {
    courseStandard: {
        initCombo: config => createAPI('/KcbzzbAdultEducation/initCombo', 'post', config),
        list: config => createAPI('/KcbzzbAdultEducation/list', 'post', config),
        createCourseStandard: config => createAPI('/KcbzzbAdultEducation/createCourseStandard', 'post', config),
        delRec: config => createAPI('/KcbzzbAdultEducation/delRec', 'post', config),
        submitRec: config => createAPI('/KcbzzbAdultEducation/submitRec', 'post', config),
        noticeTeacher: config => createAPI('/KcbzzbAdultEducation/noticeTeacher', 'post', config),
    },
    KcbzKcbzzb: {
        queOne: config => createAPI('/KcbzzbAdultEducation/queOne', 'post', config),
        update: config => createAPI('/KcbzzbAdultEducation/update', 'post', config),
        findjxdg: config => createAPI('/KcbzzbAdultEducation/findjxdg', 'post', config),
        findwnkcbz: config => createAPI('/KcbzzbAdultEducation/findwnkcbz', 'post', config),
        importmsg: config => createAPI('/KcbzzbAdultEducation/importmsg', 'post', config),
        //找到云班的历史课程标准 胡杰20210818
        findHistryKcbz: config => createAPI('/KcbzzbAdultEducation/findHistryKcbz', 'post', config),
        //徐毅骏 20220120 导入前验证被导入课程与导入课程的数据
        checkBeforImport: config => createAPI('/KcbzzbAdultEducation/checkBeforImport', 'post', config),
        //导出课程标准	WHY	20210610
        export: config => createAPI('/KcbzzbAdultEducation/export', 'post', config),
        deleteFile: config => createAPI('/KcbzzbAdultEducation/deleteFile', 'post', config),
        updateAuditState: config => createAPI('/KcbzzbAdultEducation/updateAuditState', 'post', config),
    },
    KcbzKcnryyq:{
    	queList:config =>createAPI('/KcnryyqAdultEducation/queOne', 'post', config),
    	queList2:config =>createAPI('/KcnryyqAdultEducation/queOne2', 'post', config),
    	queListByMsg:config =>createAPI('/KcnryyqAdultEducation/queListByMsg', 'post', config),
    	addMsg:config =>createAPI('/KcnryyqAdultEducation/addMsg', 'post', config),
    	deleteMsg:config =>createAPI('/KcnryyqAdultEducation/deleteMsg', 'post', config),   //删除选中的知识点技能点
    	addjobzsd:config =>createAPI('/KcnryyqAdultEducation/addjobzsd', 'post', config),	  //新增一级知识点技能点
    	findyjzsdjnd:config =>createAPI('/KcnryyqAdultEducation/findyjzsdjnd', 'post', config),	  //查找所有的一级知识点或技能点
    	findejzsdjnd:config =>createAPI('/KcnryyqAdultEducation/findejzsdjnd', 'post', config),	  //查找所有的二级知识点或技能点
    	addejzsd:config =>createAPI('/KcnryyqAdultEducation/addejzsd', 'post', config),	  //新增二级知识点技能点
    	findsjzsdjnd:config =>createAPI('/KcnryyqAdultEducation/findsjzsdjnd', 'post', config),	  //查找所有的二级知识点或技能点
    	addsjzsd:config =>createAPI('/KcnryyqAdultEducation/addsjzsd', 'post', config),//新增三级知识点技能点
    	editjobzsd:config =>createAPI('/KcnryyqAdultEducation/editjobzsd', 'post', config),//编辑一级知识点
    	editejzsd:config =>createAPI('/KcnryyqAdultEducation/editejzsd', 'post', config),//编辑二级知识点
    	editsjzsd:config =>createAPI('/KcnryyqAdultEducation/editsjzsd', 'post', config),//编辑三级知识点
    },
}

export default courseStandardAdultEducation;



// WEBPACK FOOTER //
// ./src/api/modules/courseStandardAdultEducation.js